import Dexie from "dexie";

export const db = new Dexie("scribenote-db");
/**
    id INTEGER PRIMARY KEY NOT null,
    saved_date TEXT,
    is_synced INTEGER,
    note_uuid TEXT
    blob BLOB,
    jobType TEXT,
    recordingAs TEXT,
    title TEXT,
    consentEventUuid TEXT,        -- recording-consent audit event already logged online
    pendingConsent OBJECT         -- consent affirmed offline, write deferred to resync:
                                  -- { surface, appendToNoteUuid, acknowledgedAt };
                                  -- acknowledgedAt is logged as the event's createdAt so
                                  -- the audit trail reflects the real consent moment, not
                                  -- sync time. Cleared once resync logs the event and
                                  -- fills consentEventUuid

 */
db.version(1).stores({
  unsyncedRecordings:
    "++id, saved_date, is_synced, note_uuid, jobType, recordingAs, title", // Primary key and indexed props
});
